import { render, staticRenderFns } from "./MediaSpend.vue?vue&type=template&id=6f0b9f5c&"
import script from "./MediaSpend.vue?vue&type=script&lang=js&"
export * from "./MediaSpend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports